import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import PublicLayout from "./components/site/PublicLayout";
import Home from "./pages/Home";
import Katalog from "./pages/Katalog";
import Edukasi from "./pages/Edukasi";
import ArtikelDetail from "./pages/ArtikelDetail";
import Kontak from "./pages/Kontak";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminBanners from "./pages/admin/AdminBanners";
import AdminCattle from "./pages/admin/AdminCattle";
import AdminArticles from "./pages/admin/AdminArticles";
import ArticleEditor from "./pages/admin/ArticleEditor";
import AdminSettings from "./pages/admin/AdminSettings";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/katalog" element={<Katalog />} />
          <Route path="/edukasi" element={<Edukasi />} />
          <Route path="/edukasi/:slug" element={<ArtikelDetail />} />
          <Route path="/kontak" element={<Kontak />} />
        </Route>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="banner" element={<AdminBanners />} />
          <Route path="sapi" element={<AdminCattle />} />
          <Route path="artikel" element={<AdminArticles />} />
          <Route path="artikel/baru" element={<ArticleEditor />} />
          <Route path="artikel/edit/:slug" element={<ArticleEditor />} />
          <Route path="pengaturan" element={<AdminSettings />} />
        </Route>
      </Routes>
      <Toaster richColors position="bottom-right" />
    </BrowserRouter>
  );
}
